module.exports = __webpack_public_path__ + "static/media/031.7aef08cc.jpg";